export const TravelRoutesDataTR = [
  {
    flight: {
      title: 'Popüler Uçuşlar',
      data: [
        {
          routeName: 'İzmir - İstanbul uçak bileti',
          src: 'https://www.enuygun.com/ucak-bileti/izmir-istanbul-izma-ista/',
        },
        {
          routeName: 'Adana - İstanbul uçak bileti',
          src: 'https://www.enuygun.com/ucak-bileti/adana-istanbul-adaa-ista/',
        },
        {
          routeName: 'Antalya - İstanbul uçak bileti',
          src: 'https://www.enuygun.com/ucak-bileti/antalya-istanbul-ayta-ista/',
        },
        {
          routeName: 'Diyarbakır - İstanbul uçak bileti',
          src: 'https://www.enuygun.com/ucak-bileti/diyarbakir-istanbul-diya-ista/',
        },
        {
          routeName: 'Van - İstanbul uçak bileti',
          src: 'https://www.enuygun.com/ucak-bileti/van-istanbul-vana-ista/',
        },
        {
          routeName: 'İzmir - Ankara uçak bileti',
          src: 'https://www.enuygun.com/ucak-bileti/izmir-ankara-izma-anka/',
        },
        {
          routeName: 'Adana - İzmir uçak bileti',
          src: 'https://www.enuygun.com/ucak-bileti/adana-izmir-adaa-izma/',
        },
        {
          routeName: 'Ankara - İstanbul uçak bileti',
          src: 'https://www.enuygun.com/ucak-bileti/ankara-istanbul-anka-ista/',
        },
        {
          routeName: 'Gaziantep - İstanbul uçak bileti',
          src: 'https://www.enuygun.com/ucak-bileti/gaziantep-istanbul-gzta-ista/',
        },
        {
          routeName: 'Kayseri - İstanbul uçak bileti',
          src: 'https://www.enuygun.com/ucak-bileti/kayseri-istanbul-asra-ista/',
        },
        {
          routeName: 'İstanbul - Trabzon uçak bileti',
          src: 'https://www.enuygun.com/ucak-bileti/istanbul-trabzon-ista-tzxa/',
        },
        {
          routeName: 'Malatya - İstanbul uçak bileti',
          src: 'https://www.enuygun.com/ucak-bileti/malatya-istanbul-mlxa-ista/',
        },
        {
          routeName: 'Hatay - İstanbul uçak bileti',
          src: 'https://www.enuygun.com/ucak-bileti/hatay-istanbul-htya-ista/',
        },
        {
          routeName: 'İzmir - Diyarbakır uçak bileti',
          src: 'https://www.enuygun.com/ucak-bileti/izmir-diyarbakir-izma-diya/',
        },
        {
          routeName: 'Ankara - Antalya uçak bileti',
          src: 'https://www.enuygun.com/ucak-bileti/ankara-antalya-anka-ayta/',
        },
        {
          routeName: 'Sivas - İstanbul uçak bileti',
          src: 'https://www.enuygun.com/ucak-bileti/sivas-istanbul-vasa-ista/',
        },
      ],
    },
  },
  {
    bus: {
      title: 'Otobüs Biletleri',
      data: [
        {
          routeName: 'Ankara - İstanbul otobüs bileti',
          src: 'https://www.enuygun.com/otobus-bileti/ankara-istanbul/',
        },
        {
          routeName: 'İzmir - İstanbul otobüs bileti',
          src: 'https://www.enuygun.com/otobus-bileti/izmir-istanbul/',
        },
        {
          routeName: 'İzmir - Ankara otobüs bileti',
          src: 'https://www.enuygun.com/otobus-bileti/izmir-ankara/',
        },
        {
          routeName: 'Ankara - Antalya otobüs bileti',
          src: 'https://www.enuygun.com/otobus-bileti/ankara-antalya/',
        },
        {
          routeName: 'Kayseri - Ankara otobüs bileti',
          src: 'https://www.enuygun.com/otobus-bileti/kayseri-ankara/',
        },
        {
          routeName: 'İstanbul - Bursa otobüs bileti',
          src: 'https://www.enuygun.com/otobus-bileti/istanbul-bursa/',
        },
        {
          routeName: 'İstanbul - Antalya otobüs bileti',
          src: 'https://www.enuygun.com/otobus-bileti/istanbul-antalya/',
        },
        {
          routeName: 'Adana - İstanbul otobüs bileti',
          src: 'https://www.enuygun.com/otobus-bileti/adana-istanbul/',
        },
        {
          routeName: 'Adana - Ankara otobüs bileti',
          src: 'https://www.enuygun.com/otobus-bileti/adana-ankara/',
        },
        {
          routeName: 'Bursa - Ankara otobüs bileti',
          src: 'https://www.enuygun.com/otobus-bileti/bursa-ankara/',
        },
        {
          routeName: 'Ankara - Mersin otobüs bileti',
          src: 'https://www.enuygun.com/otobus-bileti/ankara-mersin/',
        },
        {
          routeName: 'Kayseri - İstanbul otobüs bileti',
          src: 'https://www.enuygun.com/otobus-bileti/kayseri-istanbul/',
        },
        {
          routeName: 'Mersin - İstanbul Otobüs Bileti',
          src: 'https://www.enuygun.com/otobus-bileti/mersin-istanbul/',
        },
        {
          routeName: 'İzmir - Antalya otobüs bileti',
          src: 'https://www.enuygun.com/otobus-bileti/izmir-antalya/',
        },
        {
          routeName: 'İzmir - Bursa otobüs bileti',
          src: 'https://www.enuygun.com/otobus-bileti/izmir-bursa/',
        },
        {
          routeName: 'İstanbul - Samsun otobüs bileti',
          src: 'https://www.enuygun.com/otobus-bileti/istanbul-samsun/',
        },
      ],
    },
  },
  {
    otel: {
      title: 'Otel',
      data: [
        {
          routeName: 'Antalya otelleri',
          src: 'https://www.enuygun.com/otel/bolge/antalya-481/',
        },
        {
          routeName: 'Bodrum otelleri',
          src: 'https://www.enuygun.com/otel/bolge/bodrum-745/',
        },
        {
          routeName: 'Marmaris otelleri',
          src: 'https://www.enuygun.com/otel/bolge/marmaris-4302/',
        },
        {
          routeName: 'Alanya otelleri',
          src: 'https://www.enuygun.com/otel/bolge/alanya-4671/',
        },
        {
          routeName: 'Kuşadası otelleri',
          src: 'https://www.enuygun.com/otel/bolge/kusadasi-4227/',
        },
        {
          routeName: 'Fethiye otelleri',
          src: 'https://www.enuygun.com/otel/bolge/fethiye-6341134/',
        },
        {
          routeName: 'Kapadokya otelleri',
          src: 'https://www.enuygun.com/otel/bolge/kapadokya-6054888/',
        },
        {
          routeName: 'Kıbrıs otelleri',
          src: 'https://www.enuygun.com/otel/bolge/kibris-45/',
        },
        {
          routeName: 'Mersin otelleri',
          src: 'https://www.enuygun.com/otel/bolge/mersin-province-553248635458625001/',
        },
        {
          routeName: 'İzmir otelleri',
          src: 'https://www.enuygun.com/otel/bolge/izmir-1665/',
        },
        {
          routeName: 'Sapanca otelleri',
          src: 'https://www.enuygun.com/otel/bolge/sapanca-6049293/',
        },
        {
          routeName: 'Ayvalık otelleri',
          src: 'https://www.enuygun.com/otel/bolge/ayvalik-4498/',
        },
        {
          routeName: 'Didim otelleri',
          src: 'https://www.enuygun.com/otel/bolge/didim-6069857/',
        },
        {
          routeName: 'Çeşme otelleri',
          src: 'https://www.enuygun.com/otel/bolge/cesme-4275/',
        },
        {
          routeName: 'Ankara otelleri',
          src: 'https://www.enuygun.com/otel/bolge/ankara-386/',
        },
        {
          routeName: 'Eskişehir otelleri',
          src: 'https://www.enuygun.com/otel/bolge/eskisehir-7119/',
        },
      ],
    },
  },
  {
    carRental: {
      title: 'Araç Kiralama',
      data: [
        {
          routeName: 'Adana araç kiralama',
          src: 'https://www.enuygun.com/arac-kiralama/sehir/adana/',
        },
        {
          routeName: 'Ankara araç kiralama',
          src: 'https://www.enuygun.com/arac-kiralama/sehir/ankara/',
        },
        {
          routeName: 'Antalya araç kiralama',
          src: 'https://www.enuygun.com/arac-kiralama/sehir/antalya/',
        },
        {
          routeName: 'Bursa araç kiralama',
          src: 'https://www.enuygun.com/arac-kiralama/sehir/bursa/',
        },
        {
          routeName: 'Çanakkale araç kiralama',
          src: 'https://www.enuygun.com/arac-kiralama/sehir/canakkale/',
        },
        {
          routeName: 'Denizli araç kiralama',
          src: 'https://www.enuygun.com/arac-kiralama/sehir/denizli/',
        },
        {
          routeName: 'Erzurum araç kiralama',
          src: 'https://www.enuygun.com/arac-kiralama/sehir/erzurum/',
        },
        {
          routeName: 'Eskişehir araç kiralama',
          src: 'https://www.enuygun.com/arac-kiralama/sehir/eskisehir/',
        },
        {
          routeName: 'Gaziantep araç kiralama',
          src: 'https://www.enuygun.com/arac-kiralama/sehir/gaziantep/',
        },
        {
          routeName: 'Hatay araç kiralama',
          src: 'https://www.enuygun.com/arac-kiralama/sehir/hatay/',
        },
        {
          routeName: 'Isparta araç kiralama',
          src: 'https://www.enuygun.com/arac-kiralama/sehir/isparta/',
        },
        {
          routeName: 'İstanbul araç kiralama',
          src: 'https://www.enuygun.com/arac-kiralama/sehir/istanbul/',
        },
        {
          routeName: 'İzmir araç kiralama',
          src: 'https://www.enuygun.com/arac-kiralama/sehir/izmir/',
        },
        {
          routeName: 'Kastamonu araç kiralama',
          src: 'https://www.enuygun.com/arac-kiralama/sehir/kastamonu/',
        },
        {
          routeName: 'Kayseri araç kiralama',
          src: 'https://www.enuygun.com/arac-kiralama/sehir/kayseri/',
        },
        {
          routeName: 'Konya araç kiralama',
          src: 'https://www.enuygun.com/arac-kiralama/sehir/konya/',
        },
      ],
    },
  },
  {
    transfer: {
      title: 'Transfer',
      data: [
        {
          routeName: 'İstanbul Havalimanı Transferi',
          src: 'https://www.enuygun.com/transfer/istanbul-havalimani/',
        },
        {
          routeName: 'Antalya Havalimanı Transferi',
          src: 'https://www.enuygun.com/transfer/antalya-havalimani/',
        },
        {
          routeName: 'Dalaman Havalimanı Transferi',
          src: 'https://www.enuygun.com/transfer/mugla-dalaman-havalimani/',
        },
        {
          routeName: 'Sabiha Gökçen Havalimanı Transferi',
          src: 'https://www.enuygun.com/transfer/istanbul-sabiha-gokcen-havalimani/',
        },
        {
          routeName: 'Adnan Menderes Havalimanı Transferi',
          src: 'https://www.enuygun.com/transfer/izmir-adnan-menderes-havalimani/',
        },
        {
          routeName: 'Adana Havalimanı Transferi',
          src: 'https://www.enuygun.com/transfer/adana-sakirpasa-havalimani/',
        },
        {
          routeName: 'Esenboğa Havalimanı Transferi',
          src: 'https://www.enuygun.com/transfer/ankara-esenboga-havalimani/',
        },
        {
          routeName: 'Milas Bodrum Havalimanı Transferi',
          src: 'https://www.enuygun.com/transfer/bodrum-milas-havalimani/',
        },
        {
          routeName: 'Kayseri Havalimanı Transferi',
          src: 'https://www.enuygun.com/transfer/kayseri-havalimani/',
        },
        {
          routeName: 'Trabzon Havalimanı Transferi',
          src: 'https://www.enuygun.com/transfer/trabzon-havalimani/',
        },
        {
          routeName: 'Samsun Çarşamba Havalimanı Transferi',
          src: 'https://www.enuygun.com/transfer/samsun-carsamba-havalimani/',
        },
      ],
    },
  },
]
